export default __webpack_public_path__ + "static/media/VelocityStepBanner.56abeaaa.svg";